import React, { useState } from 'react';
import { Button, Form, Input, Modal, Spin,message} from "antd";
import { updateClients } from '../../Services/Services';
import TextArea from 'antd/es/input/TextArea';
import { EditOutlined } from '@ant-design/icons';
const EditClients = (props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    if (props.clientData){
        form.setFieldsValue({
        client_name :props.clientData.client_name,
        moisture_per :props.clientData.moisture_per,
        Address :props.clientData.Address,
        contact_no :props.clientData.contact_no,
        pan_no :props.clientData.pan_no,
        gst_no :props.clientData.gst_no,
    })
    }
    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onFinish = async (values) => {
        setLoading(true);
        Object.assign(values,{'com_name':localStorage.getItem('com_name')})
        const response = await updateClients(props.clientData.client_id,values);
        setLoading(false);
        if (response.msg === 'data posted') {
            message.success('Party Update Successful');
            // props.setClients(response.client_list);
            const sortedArray = [...response.client_list].sort((a, b) => b.client_id - a.client_id);
            const filterData=sortedArray.filter(o=>o.com_name===localStorage.getItem('com_name'))
            props.setClients(filterData);
            props.setclientDetails(filterData)
            setIsModalOpen(false);
            form.resetFields();
        } else {
            message.warning('Party Update Not Successful');
        }
    };
    const handlePhoneKeyPress = (e) => {
        const charCode = e.which ? e.which : e.keyCode;
        const isNumeric = charCode >= 48 && charCode <= 57; // check if the key pressed is a number
        const isBackspace = charCode === 8; // check if the key pressed is the backspace key
        const phone = e.target.value.replace(/\D/g, ''); // remove all non-numeric characters
        const isValid = phone.length === 10 || isBackspace; // check if the input is a 10-digit number or the backspace key
        if (!isNumeric && !isBackspace) {
          e.preventDefault(); // prevent the input of non-numeric characters
        }
    
        if (isValid) {
          e.target.value = phone; // update the input value with the valid phone number
        }
      };
    return (
        <>
            <Modal
                open={loading}
                footer={null}
                closable={false}
                width={400}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <img src='transduniyalogo.png' alt='img' width={200} style={{ margin: "10px" }} />

                    <Spin />
                    <h2>Party Details Updating......</h2>
                </div>
            </Modal>
            {/* <Button onClick={showModal}
                style={{
                //   margin:"10px",
                    backgroundColor: 'black',
                    color:'white',
                    fontWeight:'600'
                }}
            > */}

        <EditOutlined style={{ color: 'blue',padding:"3px" }} onClick={showModal}/>
            {/* </Button> */}
            <Modal open={isModalOpen}
                onOk={handleOk} onCancel={handleCancel}
                footer={null}
            >
                <Form
                    form={form}
                    onFinish={onFinish}
                    layout="vertical"
                >
                    <Form.Item
                        name="client_name"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Party Name!",
                            },
                        ]}
                        label={<b>Party Name</b>}
                        style={{padding:"1px",margin:"1px"}}
                    >
                        <Input placeholder="Enter Party Name" />
                    </Form.Item>

                    <Form.Item
                        name="gst_no"
                        label={<b>GST No</b>}
                        style={{padding:"1px",margin:"1px"}}
                        rules={[
                            {
                                required: true,
                                message: "Please Enter GST No!",
                            },
                        ]}
                    >
                        <Input placeholder="Enter GST No" maxLength={15} minLength={10}/>
                    </Form.Item>
                    <Form.Item
                        name="pan_no"
                        label={<b>Pan No</b>}
                        style={{padding:"1px",margin:"1px"}}
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Pan No!",
                            },
                        ]}
                    >
                        <Input placeholder="Enter Pan No" maxLength={10} minLength={10}/>
                    </Form.Item>
                    <Form.Item
                        name="contact_no"
                        label={<b>Contact No</b>}
                        rules={[

                            {
                              required: true,
                              message: "Enter Contact Number"
                            },
        
                            () => ({
                              validator(_, value) {
                                if (!value) {
                                  return Promise.reject();
                                }
                                if (isNaN(value)) {
                                  return Promise.reject("Phone has to be a number.");
                                }
                                if (value.length < 10) {
                                  return Promise.reject(
                                    "Phone number can't be less than 10 digits"
                                  );
                                }
                                if (value.length > 10) {
                                  return Promise.reject(
                                    "Phone number can't be more than 10 digits"
                                  );
                                }
                                return Promise.resolve();
                              },
                            }),
        
                          ]}
                          style={{padding:"1px",margin:"1px"}}
                    >
                        <Input placeholder="Enter Contact No" maxLength={10} minLength={10} onKeyPress={handlePhoneKeyPress}/>
                    </Form.Item>
                    <Form.Item
                        name="Address"
                        label={<b>Address</b>}
                        style={{padding:"1px",margin:"1px"}}
                    >
                        <TextArea placeholder="Address"/>
                    </Form.Item>
                    <Form.Item
                        name="moisture_per"
                        label={<b>Moisture %</b>}
                        style={{padding:"1px",margin:"1px"}}
                    >
                        <Input placeholder="Moisture %"/>
                    </Form.Item>
                    <Form.Item className="text-center" style={{ textAlign: 'center' }}>
                        <Button
                            htmlType="submit"
                              style={{ color: 'white', backgroundColor: 'black', fontSize: 'medium' }}
                        >
                            Update
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};
export default EditClients;
